import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./wq-embedded-theme.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store/store';
import {
  enforcePaymentSuccessLock,
  installPaymentSuccessBfcacheGuard,
} from './utils/paymentSuccessLock';
import { captureOpenerOrigin } from './utils/openerMessaging';

// Popup checkout: remember who opened us before any redirect changes
// document.referrer, so postMessage can target that origin instead of "*".
captureOpenerOrigin();

// After a successful payment-link payment, Back/Forward must not reopen the
// checkout or the payment-link form. If this load is such a navigation, we're
// already redirecting to /payment-success, so don't render the old page.
installPaymentSuccessBfcacheGuard();
const redirectingToSuccess = enforcePaymentSuccessLock();

if (!redirectingToSuccess) {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
      <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

